import { expected } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { Tkv2ControllerReferenceBarContext } from '../Tkv2ControllerReferenceBarContext.ts';
import { Tkv2ReferenceBarUserInterface } from '../types.ts';

// FIXME: move this out of the controller, perhaps with the reference bar component

export function useTkv2ReferenceBarUserInterface(): Tkv2ReferenceBarUserInterface;
export function useTkv2ReferenceBarUserInterface(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError: boolean,
): Tkv2ReferenceBarUserInterface;
export function useTkv2ReferenceBarUserInterface(
  iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError = false,
) {
  const msg = 'useTkv2ReferenceBarUserInterface called outside of provider';
  const refBarUserInterface = useContext(Tkv2ControllerReferenceBarContext);

  if (refBarUserInterface) return refBarUserInterface;

  const context = iKnowTheDangerAndAmWillingToAcceptAnEmptyContextInsteadOfAnError ? {} : undefined;

  return expected(context, msg);
}
